export default __webpack_public_path__ + "static/media/indicator.67685d97.svg";